export const primerLetraMayuscula = (string) =>
  string.replace(/^\w/, (c) => c.toUpperCase());